var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"layout-full_width"},[_c('div',_vm._l((_vm.list),function(el){return _c('tree-element',{key:el.id,attrs:{"id":el.id,"tree":_vm.tree},on:{"changed":_vm.update}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }